<template>
    <div>
        <QuantityPicker
                :item-id="this.stockId"
                :initial-quantity="this.quantity"
                @onSelectQuantity="selectItemQuantity"
        >
            <b-button
                    size="sm"
                    variant="primary"
                    @click="addInOffer"
            >
                <b-icon icon="file-ruled"/> Ofertează
            </b-button>

            <b-button
                    v-if="editingOrders.length > 0"
                    size="sm"
                    variant="success"
                    @click="addInOrder"
            >
                <b-icon icon="cart4"/> Comandă
            </b-button>


        </QuantityPicker>

        <b-modal ref="add-in-order-modal" title="Alege comanda" ok-only>
            <p>
                În care comandă dorești să adaugi acest produs?
            </p>

            <b-form-group>
                <b-form-radio-group
                        class="w-100"
                        button-variant="primary"
                        v-model="orderId"
                        :options="orders"
                        buttons
                        stacked
                        name="offer-options"
                ></b-form-radio-group>
            </b-form-group>

            <template v-slot:modal-footer="{ close }">
                <div class="w-100">
                    <b-button
                            variant="secondary"
                            size="sm"
                            class="mr-2"
                            @click="close()"
                    >
                        Închide
                    </b-button>
                    <b-button
                            variant="primary"
                            size="sm"
                            class="float-right"
                            :disabled="orderId === null"
                            @click="addInOrder"
                    >
                        Salvează
                    </b-button>
                </div>
            </template>
        </b-modal>
        <b-modal ref="add-in-offer-modal" title="Alege oferta" ok-only>
            <p>
                În care ofertă dorești să adaugi acest produs?
            </p>

            <b-form-group>
                <b-form-radio-group
                        class="w-100"
                        button-variant="primary"
                        v-model="offerId"
                        :options="offers"
                        buttons
                        stacked
                        name="offer-options"
                ></b-form-radio-group>
            </b-form-group>

            <template v-slot:modal-footer="{ close }">
                <div class="w-100">
                    <b-button
                            variant="secondary"
                            size="sm"
                            class="mr-2"
                            @click="close()"
                    >
                        Închide
                    </b-button>
                    <b-button
                            variant="primary"
                            size="sm"
                            class="float-right"
                            :disabled="offerId === null"
                            @click="addInOffer"
                    >
                        Salvează
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import QuantityPicker from "@/components/QuantityPicker";
    import axios from "@/utils/axios-instance";
    import store from "@/store";
    import {mapState} from "vuex";

    export default {
        name: "ProductAdder",
        components: {QuantityPicker},
        data() {
            return {
                quantity: 1,
                offerId: null,
                orderId: null,
            };
        },
        computed: {
            offers() {
                let options = [];

                options.push({ text: 'Ofertă în lucru', value: this.workingOffer.offer.offer_id });

                this.editingOffers.forEach(offer => {
                    if(offer.extra_data && offer.extra_data.clientName) {
                        options.push({
                            text: `Oferta #${offer.id} pentru ${offer.extra_data.clientName}`,
                            value: offer.id
                        });
                    } else {
                        options.push({
                            text: `Oferta #${offer.id}`,
                            value: offer.id
                        });
                    }
                });

                return options;
            },
            orders() {
                let options = [];

                this.editingOrders.forEach(order => {
                    if(order.supplier_names) {
                        options.push({
                            text: `Comanda #${order.id} pentru ${order.supplier_names}`,
                            value: order.id
                        });
                    } else {
                        options.push({
                            text: `Comanda #${order.id}`,
                            value: order.id
                        });
                    }
                });

                return options;
            },
            ...mapState(['workingOffer', 'editingOffers', 'editingOrders']),
        },
        props: ['stockId'],
        methods: {
            async addInOrder() {
                if(!this.orderId) {
                    if(this.orders.length !== 1) {
                        this.$refs['add-in-order-modal'].show()
                        return;
                    } else {
                        // There's no need to ask the user which order to put the item into if
                        // there's only one order currently open for editing

                        let myLazyOrder = this.orders[0];
                        this.orderId = myLazyOrder.value;
                    }
                }
                this.$refs['add-in-order-modal'].hide();

                let loader = this.$loading.show();

                await axios.post(`order/${this.orderId}/add-item`, {
                    product_stock_id: this.stockId,
                    quantity: this.quantity,
                })
                await store.dispatch('reloadEditingOrders');

                this.orderId = null;
                loader.hide();

                this.$bvToast.toast(`Produsul a fost adăugat în comandă!`, {
                    title: 'Succes!',
                    autoHideDelay: 5000,
                })
            },
            async addInOffer() {
                if(!this.offerId) {
                    if(this.editingOffers.length === 0) {
                        this.offerId = this.workingOffer.offer.offer_id;
                    } else {
                        this.$refs['add-in-offer-modal'].show()
                        return;
                    }
                }
                this.$refs['add-in-offer-modal'].hide();

                let loader = this.$loading.show();

                await axios.post(`offer/${this.offerId}/add-item`, {
                    product_stock_id: this.stockId,
                    quantity: this.quantity,
                })
                await store.dispatch('reloadWorkingOffer');
                await store.dispatch('reloadEditingOffers');

                this.offerId = null;
                loader.hide();

                this.$bvToast.toast(`Produsul a fost adăugat în ofertă!`, {
                    title: 'Succes!',
                    autoHideDelay: 5000,
                })
            },
            selectItemQuantity({quantity}) {
                this.quantity = quantity;
            },
        }
    }
</script>

<style scoped>

</style>